import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

    :root{
        --white: #fff;
        --black: #000;
        --paragraphSize: #1.2rem;
        --fontSuperBig: 2.5rem;
        --fontBig: 1.7rem;
        --fontMed: 1.3rem;
        --fontSmall: 1rem;
    }

    *{
        box-sizing: border-box;
        background: var(--black);
        animation: animePage 0.85s;

        @keyframes animePage{
            from{
                opacity: 0;
            }

            to{
                opacity: 1;
            }
        }
    }
`;



